import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Ventas y Cobranza" },
  { label: "Ventas",                 icon: "fas fa-money-bill-wave",     color: "#10b981", bg: "#f0fdf4", href: "/ListadoVentas",            desc: "Listado de ventas",             perm: "menu_ventas" },
  { label: "Anticipos",              icon: "fas fa-hand-holding-usd",    color: "#f59e0b", bg: "#fffbeb", href: "/ListadoAnticipos",         desc: "Anticipos de clientes",         perm: "menuAnticipos" },
  { label: "Abonos",                 icon: "fas fa-dollar-sign",         color: "#22c55e", bg: "#f0fdf4", href: "/ListadoAbonos",            desc: "Cobros aplicados",              perm: "abonos" },
  { label: "Notas de Cargo",         icon: "fas fa-money-check-alt",     color: "#ef4444", bg: "#fef2f2", href: "/ListadoNotasCargo",        desc: "Cargos adicionales",            perm: "notasCargo" },
  { label: "Devoluciones",           icon: "fas fa-undo-alt",            color: "#f97316", bg: "#fff7ed", href: "/ListadoDevolucionesAdmin", desc: "Devoluciones",                  perm: "menu_devolucionesAdmin" },
  { label: "Comisiones",             icon: "fas fa-percentage",          color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoComisiones",        desc: "Comisiones",                    perm: "comisiones" },

  { type: "section", label: "Estados de Cuenta" },
  { label: "Estado Cuenta",          icon: "fas fa-file-invoice-dollar", color: "#3b82f6", bg: "#eff6ff", href: "/EstadoCuenta",             desc: "Estado de cuenta clientes",     perm: "edoCtaClientes" },
  { label: "Estado Cuenta Vendedores", icon: "fas fa-list-ul",           color: "#0ea5e9", bg: "#f0f9ff", href: "/EstadoCuentaVendedores",   desc: "Estado por vendedor",           perm: "estado_cuenta_vendedores" },

  { type: "section", label: "Tesorería" },
  { label: "Bancos",                 icon: "fas fa-university",          color: "#6366f1", bg: "#eef2ff", href: "/Bancos",                   desc: "Cuentas bancarias",             perm: "bancos" },
  { label: "Movimientos Bancos",     icon: "fas fa-list-ol",             color: "#0891b2", bg: "#ecfeff", href: "/MovimientosBancos",        desc: "Historial de movimientos",      perm: "bancos" },
  { label: "Traspaso Dinero",        icon: "fas fa-exchange-alt",        color: "#14b8a6", bg: "#f0fdfa", href: "/ListadoTraspasosDinero",   desc: "Movimientos entre cuentas",     perm: "gastosTiendas" },

  { type: "section", label: "Reportes" },
  { label: "Inventario Costos",      icon: "fas fa-warehouse",           color: "#a855f7", bg: "#faf5ff", href: "/ListadoInventariosCostos", desc: "Valuación de inventario",       perm: "inventarios_costosAdmin" },
];

function BotonesAdmin() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-hand-holding-usd" color="#10b981" bg="#f0fdf4" title="Admin" subtitle="Ventas, cobranza y tesorería" />
        {user.configAdmin ? (
          <div className="row">
            {ITEMS.map((r, i) => {
              if (r.type === "section") return <MenuSection key={i} title={r.label} />;
              const enabled = r.permOr ? r.permOr.some((p) => !!user[p]) : !!user[r.perm];
              return <MenuCard key={i} {...r} enabled={enabled} />;
            })}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesAdmin;
